import { AuditItem } from "@deliverr/crossdock-service-client";

export const findMatchingAuditItem = (barcodeToMatch: string, auditItems: AuditItem[]) => {
  return auditItems.find(({ dsku, barcode }) => [dsku, barcode].includes(barcodeToMatch));
};

export const findMatchingAuditItemIndex = (barcodeToMatch: string, auditItems: AuditItem[]) => {
  return auditItems.findIndex(({ dsku, barcode }) => [dsku, barcode].includes(barcodeToMatch));
};
